<template>
  <div class="position-relative">
    <gmap-map
      ref="googeMap"
      :center="center"
      :zoom="12"
      style="width: 100%; height: 500px;"
      @click="activeUniversity = null"
    >
      <gmap-info-window
        v-if="hoveredUniName"
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="!!hoveredUniName"
        @closeclick="activeUniversity = null"
      />

      <gmap-marker
        :key="index"
        v-for="(marker, index) in markers"
        :position="marker.position"
        :clickable="true"
        @mouseover="onMarkerMouseOver(marker, index)"
        @mouseout="onMarkerMouseLeave(marker, index)"
        @click="toggleInfoWindow(marker, index)"
      />
    </gmap-map>
    <!-- :icon="marker.icon" -->
    <uni-map-content v-if="activeUniversity" :uni="activeUniversity" />
  </div>
</template>

<script>
import { getMarkerIconOptions } from "./helper.js";
import uniMapContent from "./uni-map-content";
export default {
  components: { uniMapContent },
  props: ["universities"],
  data() {
    return {
      center: { lat: 41.7151, lng: 44.8271 },
      activeUniversity: null,
      hoveredUniName: null,
      markers: [],
      ////////////////
      infoWindowPos: null,
      currentMidx: null,

      infoOptions: {
        content: "",
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
    };
  },

  mounted() {
    this.geolocate();
    this.initUniMarkers();
  },

  methods: {
    initUniMarkers() {
      const markers = [];
      this.universities.forEach((uni) => {
        markers.push({
          position: {
            lat: parseFloat(uni.latitude),
            lng: parseFloat(uni.longitude),
          },
          icon: getMarkerIconOptions(uni.logo),
        });
      });
      this.markers = markers;
    },

    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },

    toggleInfoWindow(marker, idx) {
      this.center = marker.position;
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.activeUniversity = null;
        this.currentMidx = null;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.currentMidx = idx;
        this.activeUniversity = this.universities[idx];
      }
    },
    onMarkerMouseOver(marker, index) {
      this.hoveredUniName = this.universities[index].name;
      this.infoOptions.content = this.hoveredUniName;
      this.infoWindowPos = marker.position;
    },
    onMarkerMouseLeave(marker, index) {
      // this.hoveredUniName = null;
      // this.infoWindowPos = null;
    },
  },
};
</script>
